//$("#ShopList > li").hide();
//$("#ShopDetail > li").hide();

//$("#ShopCityList li").click(function () {

//    var ShopListCityID = $(this).find('a').attr("data-cityid");

//    $("#ShopCityList li").removeClass("active");

//    $(this).addClass("active");
     
//    $("#ShopList > li").hide();
//    $("#ShopList > li").each(function () {

//        if ($(this).find('a').attr("data-cityid") == ShopListCityID) {
//            $(this).slideDown('normal');
//        }
//    });

//});

//$("#ShopList li").click(function () {

//    var ShopID = $(this).find('a').attr("data-id");
//    $("#ShopList li").removeClass("active");
//    $(this).addClass("active");

//    $("#ShopDetail > li").hide();
//    $("#ShopDetail > li").each(function () {

//        if ($(this).attr("data-id") == ShopID) {
//            $(this).slideDown('normal');
//        }
//    });

//});
